import React from 'react';
import { Button } from '@lwt-helix/buttons';
import { HelixIcon } from '@lwt-helix/helix-icon';
import { add } from '@lwt-helix/helix-icon/solid';
import { buttonTerms } from '../../../../constants';
import PropTypes from 'prop-types';

export const ConnectMLSButton = ({ setModal }) => {
    return (
        <div className='connect-mls d-flex justify-content-end pb-3'>
            <Button
                dataLwtId='connect-mls-button'
                size='sm'
                color='light'
                className='d-inline-flex'
                onClick={() => setModal(true)}
            >
                <HelixIcon icon={add} className='helix-brand-color' />
                {buttonTerms.connectMls}
            </Button>
        </div>
    );
};

ConnectMLSButton.propTypes = {
    setModal: PropTypes.func,
};
